var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6383 5.24412L13.5 2.09985V14.6998H17.7V7.79709C17.7 6.8386 17.3178 5.91971 16.6383 5.24412Z",
    fill: "#FFB782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7527 12.4044L0.380332 6.24543C0.142135 5.62715 0.450244 4.93263 1.06882 4.69444L12.2668 0.381064C12.8851 0.142868 13.5796 0.450976 13.8178 1.06956L16.1902 7.22851C16.4284 7.84679 16.1203 8.5413 15.5017 8.7795L4.30399 13.0929C3.68538 13.3311 2.99119 13.0227 2.7527 12.4044Z",
    fill: "#DE4C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6731 3.28809L1.24634 8.49245L2.14034 10.8132L15.5677 5.61127L14.6731 3.28809Z",
    fill: "#7A4930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.300049 8.09977V1.49979C0.300049 0.837105 0.837349 0.299805 1.50004 0.299805H13.5C14.1627 0.299805 14.7 0.837105 14.7 1.49979V8.09974C14.7 8.76243 14.1627 9.29973 13.5 9.29973H1.50004C0.837349 9.29976 0.300049 8.76246 0.300049 8.09977Z",
    fill: "#67BAF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4998 0.299805H12.2248L3.22485 9.29975H13.4998C14.1625 9.29975 14.6998 8.76245 14.6998 8.09976V1.49979C14.6998 0.837105 14.1625 0.299805 13.4998 0.299805Z",
    fill: "#52A2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69999 5.1001H1.5V5.7001H2.69999V5.1001Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69999 6.90039H1.5V7.5004H2.69999V6.90039Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10013 6.90039H6.90015V7.5004H8.10013V6.90039Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50004 5.1001H3.30005V5.7001H4.50004V5.1001Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30009 5.1001H5.1001V5.7001H6.30009V5.1001Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10013 5.1001H6.90015V5.7001H8.10013V5.1001Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1999 1.49976H12.5999V2.39975H13.1999V1.49976Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 1.49976H11.3999V2.39975H11.9999V1.49976Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 1.49976H10.2V2.39975H10.8V1.49976Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6 1.49976H9V2.39975H9.6V1.49976Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7 14.7002H12.3V17.7002H17.7V14.7002Z",
    fill: "#88B337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4194 5.71986C10.9106 5.21285 10.0871 5.21435 9.58014 5.72316C9.08993 6.21518 9.07283 7.00567 9.54143 7.51835L11.9999 10.2003C11.261 11.4936 11.2925 13.0884 12.0818 14.3514L12.2999 14.7003H16.1999V10.5003L11.4194 5.71986Z",
    fill: "#FFB782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 15.6003H13.2V16.2004H13.8V15.6003Z",
    fill: "#6B962A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.41974V1.97975C1.5 1.71454 1.71478 1.49976 1.98 1.49976H3.41998C3.68519 1.49976 3.89998 1.71454 3.89998 1.97975V3.41974C3.89998 3.68495 3.68519 3.89973 3.41998 3.89973H1.98002C1.71481 3.89973 1.5 3.68492 1.5 3.41974Z",
    fill: "#FDB62F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4 2.40039H1.5V3.0004H2.4V2.40039Z",
    fill: "#FD7B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9 2.40039H3V3.0004H3.9V2.40039Z",
    fill: "#FD7B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 10.4998C15.8204 10.4998 15.7439 10.4683 15.6878 10.4119L14.4878 9.21195C14.3726 9.09285 14.3759 8.90296 14.4953 8.78776C14.6117 8.67557 14.7959 8.67557 14.912 8.78776L16.112 9.98774C16.229 10.105 16.229 10.2949 16.112 10.4119C16.0556 10.4683 15.9794 10.4998 15.8999 10.4998Z",
    fill: "#F2A46F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 3.17819V1.49998C14.999 0.671987 14.3279 0.000885709 13.4999 0H1.49998C0.671987 0.000885709 0.000885709 0.671987 0 1.49998V8.09993C0.00239141 8.86612 0.582885 9.50661 1.34518 9.58431L2.47287 12.5117C2.77076 13.2848 3.63867 13.67 4.41174 13.3721L11.4539 10.6595C10.9673 11.9306 11.1056 13.3562 11.8277 14.51L11.9999 14.7857V17.6999C11.9999 17.8655 12.1343 17.9999 12.2999 17.9999H17.6999C17.8655 17.9999 17.9998 17.8655 17.9998 17.6999V7.79725C17.9972 6.75985 17.584 5.76596 16.8505 5.03215L14.9999 3.17819ZM14.9999 4.97216L15.9104 7.33585C16.0889 7.79964 15.8576 8.32044 15.3938 8.49894L14.8733 8.69993C14.9564 8.51092 14.9996 8.30665 14.9999 8.09993V4.97216ZM0.600009 8.09995V1.49998C0.600009 1.00289 1.00292 0.599979 1.50001 0.599979H13.4999C13.997 0.599979 14.3999 1.00289 14.3999 1.49998V3.40676H14.3973L14.3999 3.41367V8.09995C14.3975 8.15215 14.3909 8.20435 14.3795 8.25537L11.6316 5.50707C10.9992 4.88938 9.98607 4.90107 9.36838 5.53347C8.77917 6.13646 8.75877 7.09284 9.32158 7.72046L10.4931 8.99995H1.49998C1.00289 8.99995 0.600009 8.59704 0.600009 8.09995ZM4.44328 9.59993L2.30999 10.4213L1.99438 9.59993H4.44328ZM4.19607 12.8123C3.73229 12.9911 3.21149 12.7598 3.0327 12.296L2.5266 10.9799L6.10767 9.5999V9.59813H11.0429L11.4329 10.0232L4.19607 12.8123ZM17.3999 17.3999H12.5999V14.9999H17.3999V17.3999ZM17.3999 14.3999H12.4664L12.3362 14.192C11.6048 13.0232 11.5757 11.5466 12.2603 10.3499C12.3251 10.2365 12.3092 10.0946 12.221 9.99832L9.76252 7.31634C9.38993 6.90835 9.41842 6.27563 9.82641 5.90275C10.2209 5.54244 10.829 5.55564 11.2073 5.93274L15.9877 10.712L16.4119 10.2878L15.3019 9.17783L15.6098 9.05782C16.3822 8.75993 16.7671 7.89264 16.4698 7.11983L15.4543 4.48313L16.4264 5.45694C17.0474 6.07764 17.3974 6.91913 17.3998 7.79722L17.3999 14.3999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41992 4.20015C3.85073 4.20015 4.1999 3.85094 4.1999 3.42017V1.98018C4.1999 1.54937 3.8507 1.2002 3.41992 1.2002H1.97994C1.54913 1.2002 1.19995 1.5494 1.19995 1.98018V3.42017C1.19995 3.85097 1.54916 4.20015 1.97994 4.20015H3.41992ZM1.79993 3.42017V3.00016H2.39991V2.40015H1.79993V1.98018C1.79993 1.88089 1.88062 1.80017 1.97994 1.80017H3.41992C3.51921 1.80017 3.59993 1.88086 3.59993 1.98018V2.40015H2.99992V3.00016H3.59993V3.42017C3.59993 3.51945 3.51924 3.60017 3.41992 3.60017H1.97994C1.88062 3.60014 1.79993 3.51945 1.79993 3.42017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69999 5.1001H1.5V5.7001H2.69999V5.1001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69999 6.90039H1.5V7.5004H2.69999V6.90039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10013 6.90039H6.90015V7.5004H8.10013V6.90039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50004 5.1001H3.30005V5.7001H4.50004V5.1001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30009 5.1001H5.1001V5.7001H6.30009V5.1001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10013 5.1001H6.90015V5.7001H8.10013V5.1001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1999 1.49976H12.5999V2.39975H13.1999V1.49976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 1.49976H11.3999V2.39975H11.9999V1.49976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 1.49976H10.2V2.39975H10.8V1.49976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6 1.49976H9V2.39975H9.6V1.49976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 15.6003H13.2V16.2004H13.8V15.6003Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.d125335d8ffcf9b84f0b718c637820ed.svg";
export { ForwardRef as ReactComponent };